export default "__VITE_ASSET__CYeIDDMP__"